import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=6f1f0642&scoped=true&"
import script from "./Picture.vue?vue&type=script&lang=js&"
export * from "./Picture.vue?vue&type=script&lang=js&"
import style0 from "./Picture.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Picture.vue?vue&type=style&index=1&id=6f1f0642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f0642",
  null
  
)

export default component.exports